import Message from './Message';

const message = <div>We had an issue getting shifts. Please try again later and if the problem continues please send an email to <a href='mailto:help@icsecurity.com'>help@icsecurity.com</a> explaining the issue.</div>;

const Error = () => {
  return <Message message={message} />;
};

export default Error;
